webpackJsonp([144813330029149],{

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoContent = function NoContent() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'no-content-message' },
	        'There is no content available here yet! Check back later or ',
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/about' },
	            'learn more.'
	        )
	    );
	};
	
	exports.default = NoContent;
	module.exports = exports['default'];

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(19);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _NoContent = __webpack_require__(221);
	
	var _NoContent2 = _interopRequireDefault(_NoContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PoetryPage = function PoetryPage(_ref) {
	  var data = _ref.data;
	
	  var items = data.allFile === null ? [] : data.allFile.edges.map(function (item) {
	    return {
	      sizes: item.node.childImageSharp.sizes,
	      id: item.node.id
	    };
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio-title' },
	      'poetry'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio-list poetry' },
	      items.length === 0 ? _react2.default.createElement(_NoContent2.default, null) : items.map(function (item) {
	        return _react2.default.createElement(_gatsbyImage2.default, { className: 'portfolio-item', sizes: item.sizes, key: item.id });
	      })
	    )
	  );
	};
	
	exports.default = PoetryPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-poetry-index-js-a783865a8a4a8e94f6f8.js